import { connect } from "react-redux";

import { ErrorBoundary } from "./ErrorBoundary";

import type { State } from "reducers";

const mapStateToProps = (state: State) => ({
  globalState: state,
  ipForbiddenError: state.ui.ipForbiddenError,
});

export const ErrorBoundaryContainer = connect(mapStateToProps)(ErrorBoundary);
